/* S4 test: faint embers drifting behind the "Make it theirs" text column.
   Animates only while the column is on screen and the tab is visible. With reduced motion it draws one
   still frame instead; add ?embers=force to a preview URL to see the motion on a device with animations off. */
(function () {
  var host = document.querySelector('#fv2 .split .copy');
  if (!host || !window.requestAnimationFrame || !window.IntersectionObserver) { return; }
  var COUNT = 14, MAX_DPR = 2, FADE_PX = 70, ALPHA = 0.55;
  var force = /[?&]embers=force/.test(location.search);
  var still = !force && window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  var cv = document.createElement('canvas');
  cv.className = 'fv2-embers';
  cv.setAttribute('aria-hidden', 'true');
  host.insertBefore(cv, host.firstChild);
  var cx = cv.getContext('2d'), W = 0, H = 0, parts = [], visible = false, running = false;

  function size() {
    var r = host.getBoundingClientRect(), d = Math.min(window.devicePixelRatio || 1, MAX_DPR);
    W = r.width; H = r.height; cv.width = Math.max(1, W * d); cv.height = Math.max(1, H * d); cx.setTransform(d, 0, 0, d, 0, 0);
  }
  function ember(y) { return { x: Math.random() * W, y: y, vx: (Math.random() - 0.5) * 0.25, vy: -(0.2 + Math.random() * 0.55), r: 0.7 + Math.random() * 1.2 }; }
  function draw() {
    cx.clearRect(0, 0, W, H);
    parts.forEach(function (p) {
      var a = Math.min(1, (H - p.y) / FADE_PX) * ALPHA, g = cx.createRadialGradient(p.x, p.y, 0, p.x, p.y, p.r * 4);
      g.addColorStop(0, 'rgba(255,222,160,' + a + ')'); g.addColorStop(0.4, 'rgba(255,150,60,' + a * 0.6 + ')'); g.addColorStop(1, 'rgba(255,110,30,0)');
      cx.fillStyle = g; cx.beginPath(); cx.arc(p.x, p.y, p.r * 4, 0, Math.PI * 2); cx.fill();
    });
  }
  function frame() {
    if (!visible || document.hidden) { running = false; return; }
    parts.forEach(function (p) { p.x += p.vx; p.y += p.vy; p.vx += (Math.random() - 0.5) * 0.03; });
    parts = parts.filter(function (p) { return p.y > -20; });
    while (parts.length < COUNT) { parts.push(ember(H + 8)); }
    draw();
    window.requestAnimationFrame(frame);
  }
  function start() { if (!running && !still && visible && !document.hidden) { running = true; window.requestAnimationFrame(frame); } }

  size();
  for (var i = 0; i < COUNT; i++) { parts.push(ember(Math.random() * H)); }
  draw();
  window.addEventListener('resize', function () { size(); draw(); });
  new IntersectionObserver(function (es) { visible = es[0].isIntersecting; start(); }).observe(host);
  document.addEventListener('visibilitychange', start);
})();
